import React, { useState, useEffect, createRef, RefObject } from 'react'
import { Row, Col, Tag} from 'antd';
import DetailItem from "@CSIComponents/DetailItem";
import ImageGallery from 'react-image-gallery';
import ReactImageGallery from 'react-image-gallery';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import Loading from '@components/Loading';
import {getUnitOfMeasure} from '@helpers/misc/UnitOfMeasure'

const GeneralView = (props: any) => {

 


  type FilterType = {
    imageid:number,
    original:string,
    thumbnail:string
  }

  type ImageType = {
    caption?: string
    category?: string
    enddate?: string
    filesize?: string
    height?: number
    imageid: number
    imagelangid?: number
    sortorder?: number
    startdate?: string
    tags?: string
    uom?: string
    url: string
    width?: number
  }

  const galleryRef:RefObject<ReactImageGallery> = createRef()
  const [index, setIndex] = useState<number>(0)
  const [data, setData] = useState<object>({})
  const [filterData, setFilterData] = useState<[{imageid:number,original:string,thumbnail:string}]>([{
    imageid:0,
    original:'',
    thumbnail:'',
  }])

  useEffect(()=>{
    let detailData: object = {}
    let filterData:[FilterType] = [{
      imageid:0,
      original:'',
      thumbnail:'',
    }];

    if(props?.imageData && 
        props?.imageData && 
        props?.imageData?.images && 
        !!props?.imageData?.images.length) {

      props?.imageData?.images.forEach((item: ImageType,index1:number) => {
        if(index) {
            if(index1 === index) {
                detailData = item
            }
        } else {
            if(index1 === 0) {
                detailData = item
            }
        }
        
    })
    filterData.shift()
    props?.imageData?.images.forEach((item:ImageType)=> {
        filterData.push({imageid:item.imageid, original:item.url,thumbnail:item.url})
    })
  }
    setData(detailData)
    setFilterData(filterData)

  },[index,props?.imageData,props?.imageData?.images])


  const onChangeSlide = (e:number)=> {
      setIndex(e)
  }
  return (
    <>
    {
    data ?
    <div> 
      <Row gutter={24} >
        <Col span={10}>
           <div className="image-gallery-wrap"> 
                    {/* onErrorImageURL */}
                        <ImageGallery 
                            items={filterData} 
                            onSlide={(e)=>onChangeSlide(e)} 
                            renderPlayPauseButton={()=>null} 
                            renderFullscreenButton={()=>null} 
                            infinite={false}
                            ref = {galleryRef}
                            />
            </div>
          <Row style={{marginTop:"40px"}}>
            <Col span={21} className="col-margin"> 
              {/* <DetailItem value="5" label="Selected Tags" /> */}
              <div style={{ display: 'inline-block', width: '100%' }}>
                <div style={{ width: '100%', fontSize: 12, color: '#999999', height: '24px' }}>Selected Tags</div>
                <div style={{ width: '100%', padding: '0 5px', fontSize: '14px', height: '35px', marginTop: '5px', lineHeight: '32px', overflow: 'hidden' }}>
                  {
                    data['tags'] && data['tags'].split('|').map((item: any, index: any) => {
                      return <Tag key={index} style={{ borderRadius: '10px'}}>{item}</Tag>
                    })
                  }
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={13} >
          <div>
            <Row >
              <Col span={24} className="col-margin"> <DetailItem value={data['url'] ? data['url']:''} label="Image URL" /></Col>
            </Row>
            <Row >
              <Col span={11} className="col-margin"> <DetailItem value={data['width'] ? data['width']:''} label="Image Width" /></Col>
              <Col span={2}></Col>
              <Col span={11} className="col-margin"> <DetailItem value={data['height'] ? data['height']:''} label="Image Height" /></Col>
            </Row>
            <Row >
              <Col span={11} className="col-margin"> 
                <DetailItem value={data['startdate']?data['startdate']:''} label="Start Date" />
              </Col>
              <Col span={2}></Col>
              <Col span={11} className="col-margin"> <DetailItem value={data['enddate'] ? data['enddate']:''} label="End Date" /></Col>
            </Row>
            <Row >
              <Col span={11} className="col-margin"><DetailItem value={data['category'] ? data['category']:''} label="Category" /></Col>
              <Col span={2}></Col>
              <Col span={11} className="col-margin">
                <DetailItem value={data['sortorder'] ? data['sortorder']:''} label="Sort Order" />
              </Col>
            </Row>
            <Row >
              <Col span={11} className="col-margin"> 
                <DetailItem value={data['filesize'] ? data['filesize']:''} label="File Size" /></Col>
              <Col span={2}></Col>
              <Col span={11} className="col-margin"> 
                <DetailItem value={data['uom'] ? getUnitOfMeasure(data['uom']):''} label="Unit of Measure" />
              </Col>
            </Row>
           </div>
        </Col>
      </Row>
      <Row>
        <Col span={23} className="col-margin">
          <DetailItem value={data['caption']} label="Caption" />
        </Col>
      </Row>
      </div>: <Loading type="large" />
      }
     
    </>
  )
}


export default GeneralView;